<template>
  <div class="h-100">
    <nav class="navbar navbar-expand-lg p-0">
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav w-100 top-nav-bar">
          <a
            class="nav-item nav-link w-50"
            v-for="panel in topNavList"
            v-on:click="getEventHandler('onClick', panel.onEvents, panel)"
            :key="panel.label"
            :class="(activeIndex === panel.label)?'active':'inactive'"
            style="width: 20% !important"
            >{{ panel.label }}<span class="sr-only">(current)</span></a
          >
        </div>
      </div>
    </nav>
    <div class="col-md-12 p-0" style="height: calc(100vh - 120px)">
      <component
        :is="selectedComponent"
        v-bind="currentProperties"
        class="h-100"
      ></component>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import ExternalImportExportSettingsPluginLoader from "./ImportExportSettingsPlugin.vue";
import Utils from "../../components.utils.js";

export default {
  data() {
    return {
      activeIndex: "",
      topNavList: [],
      selectedComponent: "external-import-export-plugin-loader",
      selectedPluginInfo: null,
    };
  },
  components: {
    "external-import-export-plugin-loader":
      ExternalImportExportSettingsPluginLoader,
  },
  computed: {
    currentProperties() {
      if (this.selectedComponent == "external-import-export-plugin-loader") {
        if (this.selectedPluginInfo == undefined || this.selectedPluginInfo == null){
            return { pluginInfo:  this.selectedPluginInfo};
        }else{
            return { pluginInfo: this.selectedPluginInfo };
        }
      } else {
        return {};
      }
    },
  },
  methods: {
    getDefaultSelectedPluginInfo(){
        for (let menu of this.getRegisteredImportExportMenus()) {
          if (Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), menu.privilege)){
              if(this.topNavList.indexOf(menu.id)== -1){  
                this.topNavList.push(menu)
              }  
          }
        }

        let panel = this.topNavList[0];
        this.activeIndex = panel.label;
        this.selectedPluginInfo = panel;
        // return panel
    },
    changeComponent(comp, label) {
      (this.activeIndex = label), (this.selectedComponent = comp);
    },
    changeComponentToExternalPlugin(label) {
      this.changeComponent("external-import-export-plugin-loader", label);
    },
    getEventHandler(eventname, supportedEvents, pluginInfo) {
      this.selectedPluginInfo = null;
      if (pluginInfo) {
        console.log("[pluginInfo]", pluginInfo);
        this.selectedPluginInfo = Object.assign({}, pluginInfo);
        return this.changeComponentToExternalPlugin(pluginInfo.label);
      } else {
        let event = supportedEvents.filter(
          (eventInfo) => eventInfo.event_name == eventname
        );
        if (event.length != 0) {
          return event[0]["event_handler"]();
        }
      }
    },
    ...mapGetters("registry", ["getRegisteredImportExportMenus"]),
    ...mapGetters("users",["getLoggedInUserPrivilege"]),
    ...mapMutations("registry", [
      "registerImportExportSettingsMenu",
      "unSetImportExportSettingsMenu",
    ]),
  },
  created(){
    this.getDefaultSelectedPluginInfo();
  },
  mounted() {
    // this.setUpImportExportSettingsTopNav(this.topNavList);
  },
};
</script>

<style scoped lang="scss">
$active-blue: #007bff;
$options-text-color: #9c9c9c;
$text-color: #eee;
$body-bg-color: #1a1e21;
$white-text: #fff;
$header-background: #181818;

.nav-item {
  color: $options-text-color !important;
}
.inactive:hover{
  color:$text-color !important;
}
.active {
  // background: $body-bg-color !important;
  color:$active-blue !important;
  border-bottom: 2px solid $active-blue ;
}
.top-nav-bar {
  background: transparent;
}
</style>
